module.exports = __webpack_public_path__ + "static/comp-4768a5d9408569823188d9ab291cdbe1.png";